import { NgModule } from '@angular/core';
import { AutoSaveStatusComponent } from '@configuration/shared/auto-save/auto-save-status.component';
import { AutoSaveDirective } from '@configuration/shared/auto-save/auto-save.directive';
import { ModalsAccountsComponent } from '@configuration/shared/components/modals/accounts/modals.accounts.component';
import { ModalsCardsComponent } from '@configuration/shared/components/modals/cards/modals.cards.component';
import { ModalsCustomNotificationsComponent } from '@configuration/shared/components/modals/custom-notifications/modals.custom-notifications.component';
import { ModalsJobsComponent } from '@configuration/shared/components/modals/jobs/modals.jobs.component';
import { ModalsEditJobsComponent } from '@configuration/shared/components/modals/jobs/modals.edit-jobs.component';
import { ModalsLeadTypeNotificationsComponent } from '@configuration/shared/components/modals/lead-type-notifications/modals.lead-type-notifications.component';
import { ModalsIntegrationsComponent } from '@configuration/shared/components/modals/integrations/modals.integrations.component';
import { ModalsReferenceRelationshipEditComponent } from '@configuration/shared/components/modals/reference-relationship-edit/modals.reference-relationship-edit.component';
import { ModalsReferenceRelationshipsComponent } from '@configuration/shared/components/modals/reference-relationships/modals.reference-relationships.component';
import { ModalsSettingsSearchComponent } from '@configuration/shared/components/modals/settings-search/modals.settings-search.component';
import { NotificationMatrixComponent } from '@configuration/shared/components/notification-matrix/notification-matrix.component';
import { ModalsSubscriptionsComponent } from '@configuration/shared/components/modals/subscriptions/modals.subscriptions.component';
import { ConfigurationNavbarComponent } from '@configuration/shared/components/navbar/navbar.component';
import { ConfigurationTopbarComponent } from '@configuration/shared/components/topbar/topbar.component';
import { SettingAnchorDirective } from '@configuration/shared/settings-search/setting-anchor.directive';
import { SharedModule } from '@shared/shared.module';

const components = [
  ConfigurationNavbarComponent,
  ConfigurationTopbarComponent,

  // Auto-save
  AutoSaveStatusComponent,

  // Notifications tab
  NotificationMatrixComponent,

  // Modals
  ModalsAccountsComponent,
  ModalsCardsComponent,
  ModalsIntegrationsComponent,
  ModalsReferenceRelationshipEditComponent,
  ModalsReferenceRelationshipsComponent,
  ModalsSubscriptionsComponent,
  ModalsCustomNotificationsComponent,
  ModalsLeadTypeNotificationsComponent,
  ModalsJobsComponent,
  ModalsEditJobsComponent,
  ModalsSettingsSearchComponent,

  // Directives
  AutoSaveDirective,
  SettingAnchorDirective
];

@NgModule({
  imports: [SharedModule],
  exports: [SharedModule, components],
  declarations: [components]
})
export class ConfigurationSharedModule {}
